import { render, staticRenderFns } from "./VeSettingsPanel.vue?vue&type=template&id=0f8597bf&scoped=true"
import script from "./VeSettingsPanel.vue?vue&type=script&lang=js"
export * from "./VeSettingsPanel.vue?vue&type=script&lang=js"
import style0 from "./VeSettingsPanel.vue?vue&type=style&index=0&id=0f8597bf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8597bf",
  null
  
)

export default component.exports